import React from 'react';
import { RunAnalysisPage } from './RunAnalysisPage';

export const RunAnalysisAdapter: React.FC = () => {
  return <RunAnalysisPage />;
};
